import React, { useState, useEffect } from 'react';
import dryEditorClass from './DryEditorClass';
import schema from './schema';
import FastTooltip from '../../components/FastTooltip';
import constants from '../../constants';

const { EDITOR_COMMAND_NAME_MAP } = constants;

const getLevelFromState = (editorState) => {
  if (!editorState) return null;
  try {
    const { $from } = editorState.selection;
    const node = $from.parent;
    if (node && node.type === schema.nodes.heading) {
      return node.attrs.level;
    }
    return 0;
  } catch (_) {
    return null;
  }
};

const HEADING_BUTTONS = [
  { level: 0, label: '¶', tooltip: 'Paragraph' },
  { level: 1, label: 'H1', tooltip: 'Heading 1' },
  { level: 2, label: 'H2', tooltip: 'Heading 2' },
  { level: 3, label: 'H3', tooltip: 'Heading 3' },
];

const HeadingButtons = () => {
  const [activeLevel, setActiveLevel] = useState(null);

  useEffect(() => {
    dryEditorClass.registerTransactionHandler({
      name: 'headingButtons',
      method: (state) => setActiveLevel(getLevelFromState(state)),
    });
    return () => dryEditorClass.registeredTransactionHandlers.delete('headingButtons');
  }, []);

  const applyHeading = (level, e) => {
    e.preventDefault();
    dryEditorClass.execCommands([{
      commandName: EDITOR_COMMAND_NAME_MAP.heading,
      options: { level },
    }]);
  };

  return (
    <>
      {HEADING_BUTTONS.map(({ level, label, tooltip }) => (
        <FastTooltip key={level} title={tooltip}>
          <button
            className={`editor-button heading-btn${activeLevel === level ? ' active' : ''}`}
            onMouseDown={(e) => applyHeading(level, e)}
            aria-pressed={activeLevel === level}
            type="button"
          >
            <span className="heading-btn__label">{label}</span>
          </button>
        </FastTooltip>
      ))}
    </>
  );
};

export default HeadingButtons;
